<header matDialogTitle>
  <div>Add period</div>
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>

<form [formGroup]="form" matDialogContent>
  <mat-form-field appearance="outline" class="date-input">
    <mat-label>From (start of day)</mat-label>
    <input matInput [matDatepicker]="fromTimePicker" formControlName="fromTime" appAutofocus />
    <mat-datepicker-toggle matSuffix [for]="fromTimePicker"></mat-datepicker-toggle>
    <mat-datepicker #fromTimePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline" class="date-input">
    <mat-label>To (end of day)</mat-label>
    <input matInput [matDatepicker]="toTimePicker" formControlName="toTime" />
    <mat-datepicker-toggle matSuffix [for]="toTimePicker"></mat-datepicker-toggle>
    <mat-datepicker #toTimePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput type="text" appTrimValue formControlName="name" />
  </mat-form-field>
</form>

<div matDialogActions>
  <button (click)="close()" [disabled]="form.invalid || form.pristine" mat-raised-button color="primary" type="button">
    Add
  </button>
  <button mat-button type="button" color="primary" matDialogClose>Cancel</button>
</div>
